require('./rightsProfileSection.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const moment = require('moment');
const lodash = require('lodash');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTag = require('components/commons/OKTag/OKTag');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @actions
const rightsActions = require('actions/rightsProfile');

// @helpers
const rightsProfileHelper = require('utilities/rightsProfileHelper');
const dateHelper = require('utilities/dateHelper');

// @constants
const {
    DATE_FORMAT_API,
    EXPIRED_RIGHTS,
    ERROR_RIGHTS
} = require('constants/index');
const { RIGHTS_LINK } = require("constants/flagBasedFeatures");

class RightsProfileSection extends React.Component {

    constructor(props) {
        super(props);

        this.buildRightsTable = this.buildRightsTable.bind(this);
    }

    buildRightsTable() {
        const { immRightsProfile } = this.props;
        const immRightsProfileFilter = lodash.filter(immRightsProfile.get('rights'), function (right) {
            let rightFilter = right ? right.status !== EXPIRED_RIGHTS : null
            return rightFilter;
        });
        let rightsProfileTable = immRightsProfileFilter.map((rights, index) => {
            const rightsType = rightsProfileHelper.getTypeRights(rights.type);
            const rightsState = rightsProfileHelper.getRightsState(rights.status);
            const rightDate = moment(rights.date);
            const date = dateHelper.isToday(rightDate) ? 'Hoy' : rightDate.format(DATE_FORMAT_API);
            let tagType;

            if ([ERROR_RIGHTS, EXPIRED_RIGHTS].includes(rights.status)) {
                tagType = 'warning'
            }

            return (
                <OKTableRow asHeader={false} key={index.toString()}>
                    <OKTableCell
                        className="rights-profile-section__date-cell"
                    >
                        {date}
                    </OKTableCell>
                    <OKTableCell
                        className="rights-profile-section__title-cell"
                    >
                        <FormattedText value={rightsType} />
                    </OKTableCell>
                    <OKTableCell
                        className="rights-profile-section__state-cell"
                    >
                        <OKTag content={rightsState} context="arrow" type={tagType} />
                    </OKTableCell>
                </OKTableRow>
            )
        });

        return (
            <OKTable>
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            className="rights-profile-section__date-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsProfile-dateHeaderCell" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            className="rights-profile-section__title-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsProfile-titleHeaderCell" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell
                            className="rights-profile-section__state-header-cell"
                            asHeader={true}
                        >
                            <FormattedText value="rightsProfile-stateHeaderCell" format="uppercase" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {rightsProfileTable}
                </tbody>
            </OKTable>
        )
    }

    render() {
        // const { immRightsProfile } = this.props;
        const { immFlagBasedFeatures } = this.props;
        const showTable = false; //immRightsProfile.get('rights').length > 0;
        const rightDescText = immFlagBasedFeatures.get(RIGHTS_LINK) ? "rightsProfile-description" : "rightsProfile-descriptionDisabled";

        return (
            <OKSectionBox className="rights-profile-section" title={formatText('rightsProfile-title')}>
                <div className="row">
                    <div className="col-xs-12 content-no-padding rights-profile-section__description">
                        <FormattedText value={rightDescText} />
                    </div>
                    {showTable && this.buildRightsTable()}
                    <div className="col-xs-12 content-no-padding last-cell">
                        <FeatureTogglingRender notAllowedProductKey={RIGHTS_LINK}>
                            <OKLink modifier="complementary" to="/myprofile/rights">
                                <FormattedText value="rightsProfile-link" />
                            </OKLink>
                        </FeatureTogglingRender>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}

RightsProfileSection.propTypes = {
    rightsActions: PropTypes.func,
    immRightsProfile: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object
};

RightsProfileSection.defaultProps = {
    rightsActions: () => { },
    immRightsProfile: {}
};

module.exports.constructor = RightsProfileSection;

module.exports.RightsProfileSection = connect(
    state => ({
        immRightsProfile: state.rightsProfile,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    dispatch => ({
        rightsActions: bindActionCreators(rightsActions, dispatch)
    })
)(RightsProfileSection);
